import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

interface Props {
  message: MessageEvent;
  delay: number;
}

const ReceivedMessage: React.FC<Props> = ({ message, delay }) => {
  return (
    <div className="card">
      <Card>
        <CardContent>
          <Typography variant="h6">
            <b>Origin: </b>
            {message.origin}
          </Typography>
          <Typography variant="h6">
            <b>Event: </b>
            {message.data.event}
          </Typography>
          <Divider />
          <br></br>
          <Typography variant="body1">
            <b>Full Event Payload:</b>
          </Typography>
          <pre>{JSON.stringify(message.data, null, 2)}</pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReceivedMessage;
